/* eslint-disable camelcase, max-statements */
import { useReport } from "../ReportContext";
import { useUser } from "../../UserContext"

const ranges = ["very_low", "low", "medium", "high", "very_high"]

const SelfOtherOrientationAssessment = () => {
	const { respondent } = useUser();
	const { reportContent: { acf: { self_other } } } = useReport();

	const percentile = parseInt( respondent?.weqProfile?.percentiles?.self_Other_Focus_Balance / 20, 10);
	const range = ranges[percentile];

	if ( ['medium', 'low', 'very_low'].includes(range) ) {
		const selfIsGreater = respondent?.weqProfile?.percentiles?.self_Oriented_dist > respondent?.weqProfile?.percentiles?.other_Oriented_dist;
		if (selfIsGreater) {
			if ( self_other[ `${range}_self` ] ) {
				return <div className={`assessment-text rating-${range}`} dangerouslySetInnerHTML={{ __html: self_other[ `${range}_self` ] }} />
			} else if ( self_other[ range ] ) {
				return <div className={`assessment-text rating-${range}`} dangerouslySetInnerHTML={{ __html: self_other[ range ] }} />
			}
		} else if ( self_other[ `${range}_other` ] ) {
			return <div className={`assessment-text rating-${range}`} dangerouslySetInnerHTML={{ __html: self_other[ `${range}_other` ] }} />
		} else if ( self_other[ range ] ) {
			return <div className={`assessment-text rating-${range}`} dangerouslySetInnerHTML={{ __html: self_other[ range ] }} />
		}
	}
	return <div className={`assessment-text rating-${range}`} dangerouslySetInnerHTML={{ __html: self_other[ range ] }} />
}

export default SelfOtherOrientationAssessment;